// ABOUTME: Floating back and next/done buttons for the post-login news popup carousel.
// ABOUTME: Shared by the stockhub article viewer and the fulfilment (relation) news viewer.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import Shbutton from "../../../../theme/buttons/Shbutton";

const NewsCarouselButtons = ({ onNext, onBack, nextIsLast }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <>
            {/* Carousel back button */}
            {onBack && (
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 24,
                        left: 24,
                        zIndex: 10,
                    }}
                >
                    <Shbutton
                        color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                        variant="contained"
                        onClick={onBack}
                        startIcon={<ArrowBackIcon />}
                    >
                        {t("back") || "Terug"}
                    </Shbutton>
                </Box>
            )}

            {/* Carousel next/done button */}
            {onNext && (
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 24,
                        right: 24,
                        zIndex: 10,
                    }}
                >
                    <Shbutton
                        color={nextIsLast ? theme.palette.mode === "dark" ? "blue" : "primary" : theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                        variant="contained"
                        onClick={onNext}
                        endIcon={nextIsLast ? <CheckIcon /> : <ArrowForwardIcon />}
                    >
                        {nextIsLast ? t("done") : t("next")}
                    </Shbutton>
                </Box>
            )}
        </>
    );
};

export default NewsCarouselButtons;
